/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { CustomWindow } from '@/main';

declare let window: CustomWindow;

export interface LogFn {
    (message?: any, ...optionalParams: any[]): void;
}

export interface Logger {
    debug: LogFn;
    warn: LogFn;
    error: LogFn;
}

import.meta.env.MODE;

export class ConsoleLogger implements Logger {

    readonly debug: LogFn;
    readonly warn: LogFn;
    readonly error: LogFn;

    constructor() {

        this.error = console.error.bind(console);

        this.warn = console.warn.bind(console);

        this.debug = (message, ...optionalParams) => {
            const VITE_MODE = import.meta.env.MODE;
            const DEBUG_ENABLED = VITE_MODE === 'development' || window.__DEBUG_LOGS_ENABLED;

            if (DEBUG_ENABLED) {
                console.debug.apply(null, [message, ...optionalParams]);
            } else {
                return;
            }
        };

    }
}

export const logger = new ConsoleLogger();
